"use strict"
import React, { useContext, useMemo, useState, useEffect } from 'react'
import { LanguageContext } from '../context'
import { Link } from 'react-router-dom'

const NewsCarouselContinuous = ({ mobile = false, offset = 0, filteredNews, delay = 0, interval = 3.5 }) => {

  const { t, localizedProperty } = useContext(LanguageContext)
  const screenWidth = window.innerWidth

  const THUMB_SIZE_PX = mobile ? 100 : 130
  const GAP_SIZE_PX = mobile ? 80 : 100
  const ITEM_SHIFT_PX = THUMB_SIZE_PX + GAP_SIZE_PX
  
  const totalItemsWidth = filteredNews.length * ITEM_SHIFT_PX
  const animationDuration = (totalItemsWidth / ITEM_SHIFT_PX) * interval * 1000

  const carouselStyle = {
    display: 'flex',
    gap: `${GAP_SIZE_PX}px`,
    animation: `carouselScroll ${animationDuration}ms linear infinite`,
    animationDuration: `${animationDuration}ms`,
  }

  return (
    <div className='w-full'>
      <div
        className='flex news-carousel__continuous-track'
        style={carouselStyle}
      >
        {filteredNews.concat(filteredNews).map((newsItem, index) => {
          const imageUrl = newsItem.image?.url
          const title = localizedProperty(newsItem, 'title') || t('home.news_title')
          const alt = newsItem.image?.caption || title
          return (
            <Link to={`/news/${newsItem.id}`} key={`carousel-news-item-${newsItem.id}`} className={`home-news__item`}>
              {imageUrl ? (
                <img className='home-news__image' src={imageUrl} alt={alt} loading="lazy" />
              ) : (
                <div className='home-news__placeholder' aria-label={title} />
              )}
            </Link>
          )}
        )}
      </div>
    </div>
  )
}

export default NewsCarouselContinuous
